import { defineMessages } from 'react-intl';

export default defineMessages({
  toggleOpen: {
    id: 'combobox.toggle-open',
    defaultMessage: 'Open',
  },
  toggleClose: {
    id: 'combobox.toggle-close',
    defaultMessage: 'Close',
  },
});
